import * as e from "react";
import { forwardRef as c } from "react";
const n = ({ title: a, titleId: t, ...l }, r) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 22, viewBox: "0 0 14 22", role: "img", ref: r, "aria-labelledby": t, ...l },
  a ? e.createElement("title", { id: t }, a) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "m6.535 14.715-5.25-5.25c-.273-.246-.273-.656 0-.93.246-.246.656-.246.93 0L7 13.348l4.785-4.786c.246-.273.656-.273.93 0a.644.644 0 0 1 0 .903l-5.277 5.25a.6.6 0 0 1-.903 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "089cb08a4a23034cce0572ced2f706b6__a" },
      e.createElement("path", { d: "M0 0h14v22H0z" })
    )
  )
), m = c(n);
export {
  m as F
};
